var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.004,
    viewBox: "0 0 16 16.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-settings",
    "data-name": "Icon ionic-ios-settings",
    d: "M19.179,12.5A2.059,2.059,0,0,1,20.5,10.579,8.161,8.161,0,0,0,19.513,8.2a2.086,2.086,0,0,1-.837.179A2.054,2.054,0,0,1,16.8,5.487,8.136,8.136,0,0,0,14.421,4.5a2.057,2.057,0,0,1-3.842,0A8.161,8.161,0,0,0,8.2,5.488,2.054,2.054,0,0,1,6.321,8.379,2.019,2.019,0,0,1,5.483,8.2,8.341,8.341,0,0,0,4.5,10.583a2.058,2.058,0,0,1,0,3.842A8.161,8.161,0,0,0,5.492,16.8,2.055,2.055,0,0,1,8.2,19.517a8.209,8.209,0,0,0,2.379.988,2.053,2.053,0,0,1,3.833,0,8.161,8.161,0,0,0,2.379-.988A2.057,2.057,0,0,1,19.508,16.8a8.209,8.209,0,0,0,.987-2.379A2.069,2.069,0,0,1,19.179,12.5Zm-6.642,3.329A3.333,3.333,0,1,1,15.871,12.5,3.332,3.332,0,0,1,12.538,15.829Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#474747",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.c42a07aae0c4de85f3ba6e794b83d416.svg";
export { ForwardRef as ReactComponent };